import React, { useState } from "react";
import { changeDesiredVolume } from "features/streamLayout/layoutSlice";
import { useAppDispatch } from "app/hooks";
import Form from "react-bootstrap/Form";
import { VolumeDown, VolumeUp, ArrowRepeat } from "react-bootstrap-icons";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

interface VolumeControlProps {
  presetVolume: number;
}

export const VolumeControl = (props: VolumeControlProps) => {
  const presetVolume = props.presetVolume;
  const [desiredVolume, setDesiredVolume] = useState(presetVolume);
  const dispatch = useAppDispatch();

  const onVolumeChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(changeDesiredVolume(parseInt(ev.target.value)));
  };
  var content = null;
  if (presetVolume === -1) {
    content = (
      <Row>
        <Col xs={2}></Col>
        <Col xs={8}>
          <ArrowRepeat size={32} />
        </Col>
        <Col xs={2}></Col>
      </Row>
    );
  } else
    content = (
      <Row>
        <Col xs={2}>
          <VolumeDown size={32} />
        </Col>
        <Col xs={8}>
          <Form.Range
            min={0}
            max={100}
            defaultValue={presetVolume}
            onChange={onVolumeChange}
          />
        </Col>
        <Col xs={2}>
          <VolumeUp size={32} />
        </Col>
      </Row>
    );

    return content;
};
